import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt, faClock } from "@fortawesome/free-solid-svg-icons";
import UserProfileCard from "../../components/portfolio/UserProfileCard";
import Slider from "react-slick";
import ContentLoader from "../../components/ContentLoader";
import moment from "moment";
import NewsletterSubscription from "../../components/portfolio/BlogPage/NewsletterSubscription";
import BlogPageCard from "../../components/portfolio/BlogPage/BlogPageCard";
import { FormattedMessage, injectIntl } from "react-intl";
import CKContent from '../../components/CKContent'
import MetaTags from '../../components/SEO/MetaTags'
import { handlePublicRequestError, Request } from '../../helpers/request'
import { getPublicProfilePicture } from '../../helpers/auth'
import { addLocalePrefix } from '../../components/Routes/LocaleLink'
import { HtmlTagSchemaMarkup } from '../../components/SEO/HtmlTagSchemaMarkup'
import Helmet from 'react-helmet'
import { helmetJsonLdProp } from 'react-schemaorg'

class ArticleViewPage extends Component {
    state = {
        data: null,
        articles: null
    };

    componentDidMount() {
        this.fetchArticle();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.match.params.slug !== prevProps.match.params.slug)
            this.fetchArticle();
    }

    fetchArticle() {
        Request.get('articles/slug/' + this.props.match.params.slug)
            .then((data) => {
                if (Object.keys(data).length === 0) {
                    this.props.history.push(addLocalePrefix('/404'))
                }
                this.setState({ data }, () => this.state.data.category.slug == ('press' || 'presse') ? this.fetchPressArticles() : this.fetchArticles())
            })
            .catch(() => this.props.history.push(addLocalePrefix('/404')));
    }

    fetchArticles() {
        Request.get('articles?pagination=4&categories=' + this.state.data.category.slug + '&except=' + this.state.data.id)
            .then((articles) => this.setState({ articles: articles.data }))
            .catch(handlePublicRequestError);
    }

    fetchPressArticles() {
        Request.get('press_articles?pagination=4&except=' + this.state.data.id)
            .then((articles) => this.setState({ articles: articles.data }))
            .catch(handlePublicRequestError());
    }

    settings = {
        dots: true,
        infinite: this.state.articles ? this.state.articles.length > 4 : false,
        arrows: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        adaptiveHeight: false,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    adaptiveHeight: false
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    adaptiveHeight: true
                },
            },
        ]
    };

    render() {
        return (
            <div className="blog-details-page">
                {this.renderContent()}
            </div>
        )
    }

    renderJsonLd() {
        const { data } = this.state;

        return (
            <Helmet
                script={[
                    helmetJsonLdProp({
                        '@context': 'https://schema.org',
                        '@type': 'Article',
                        headline: data.title,
                        abstract: data.hat,
                        datePublished: data.published_at,
                        about: data.category.name,
                        author: {
                            '@type': 'Person',
                            givenName: data.user.firstname,
                        },
                        image: data.attachment.url,
                    }),
                ]}
            />
        )
    }

    renderContent() {
        const { data } = this.state;

        if (!data)
            return <ContentLoader />;

        return (
            <>
                <MetaTags page="blog_slug" data={data} />
                <HtmlTagSchemaMarkup type="Article" />
                {this.renderJsonLd()}

                <section className="blog-details">
                    <Container>
                        <div className="blog-detail-img">
                            <img
                                src={data.attachment ? data.attachment.url : ''}
                                alt={data.seo_image_alt ?? 'title'}
                            />
                        </div>
                        <div className="blog-details-wrap">
                            <div className="blog-detail-head">
                                <div className={"blog-details-title " + data.category.color}>
                                    <h1>
                                        {data.title}
                                    </h1>
                                    <ul className="blog-post-time">
                                        <li>
                                            <div className="post-user">
                                                <figure className={data.category.color}>
                                                    <img src={getPublicProfilePicture(data.user)} alt="user" />
                                                </figure>
                                                <span>{data.user.firstname}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <i className={'mr-2'}>
                                                <FontAwesomeIcon icon={faCalendarAlt} className="icon" />&nbsp;
                                            </i>
                                            {moment(data.published_at ? data.published_at : new Date()).format('DD.MM.YYYY')}
                                        </li>
                                        <li>
                                            <i className={'mr-2'}>
                                                <FontAwesomeIcon icon={faClock} className="icon" />&nbsp;
                                            </i>
                                            {data.reading_time ? data.reading_time : '5'} MIN
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="blog-detail-text">
                                <CKContent data={data.content} className="blog-text-inner" />

                                {this.renderArticleCta()}
                                <UserProfileCard user={data.user} >
                                    <NewsletterSubscription className="newsletter-container-desktop" />
                                </UserProfileCard>

                                <NewsletterSubscription className="newsletter-container-mobile" />
                            </div>
                        </div>
                    </Container>
                </section>

                {this.state.articles && this.state.articles.length
                    ?
                    <section className="sec-gallery">
                        <div className="container">
                            <h2>
                                <FormattedMessage
                                    id="portfolio.blog.recommendations"
                                    defaultMessage="LES ARTICLES QUI POURRAIENT VOUS INTERESSER"
                                />
                            </h2>
                            <div className="gallery">
                                {this.renderGallery()}
                            </div>
                        </div>
                    </section>
                    :
                    null
                }
            </>
        )
    }

    renderArticleCta() {
        const { data } = this.state;
        if (!data.cta_link) {
            return null
        }

        const target = data.cta_target_blank ? '_blank' : '_self'
        return (
            <div className="article-cta-container">
                <a href={data.cta_link} target={target} className="btn btn-danger">
                    {data.cta_label}
                </a>
            </div>
        )
    }

    renderGallery() {

        const { articles } = this.state;

        return (
            <Slider className="gallery-wrap blog-list" {...this.settings}>
                {
                    articles.map((card, key) => {
                        return (
                            <BlogPageCard
                                data={card}
                                key={key}
                            />
                        )
                    })}
            </Slider>
        )
    }
}

export default injectIntl(ArticleViewPage);
